<template>
    <div>

         <CustomModal v-if="isModalOpen" ref="customModal" :modalId="modalId" :isOpen="isModalOpen" :showFooter="true" @modalClosed="modalClosed" :isStyle="'max-width:100% !important;'">
            
            <template #header>
                <h5 class="modal-title">{{ ['create','transfer'].includes(action) ? $t('create_invoice') : $t('edit_invoice') }}</h5>
                <button type="button" class="btn-close" id="close-modal-btn" data-bs-dismiss="modal" aria-label="Close" @click="modalClosed"></button>
            </template>

            <template #body>
                <div class="modal-body" style="text-align:left; position: relative;">
                        <!-- Loading Overlay -->
                        <div v-if="loading" class="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75" style="z-index: 1050;">
                            <div class="text-center">
                                <div class="spinner-border text-primary mb-2" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                <p class="mb-0 text-muted">{{$t('loading')}}...</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-3">
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1"  class="form-label">{{$t('purchase')}}</label>
                                     <auto-complete 
                                        entity="purchases"
                                        emitEvent="emitAutoCompletePurchase"
                                        :defaultValue="localData?.purchase?.reference" 
                                        @emitAutoCompletePurchase="emitAutoCompletePurchase">
                                    </auto-complete>
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1"  class="form-label">{{$t('reference')}}</label>
                                    <input v-model="localData.reference" type="string" class="form-control" id="exampleFormControlInput1" placeholder="Reference">
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="mb-3">
                                <label for="exampleFormControlInput1" class="form-label">{{$t('date')}}</label>
                                <input v-model="localData.date" type="date" class="form-control" id="exampleFormControlInput1" placeholder="Reference Date">
                            </div>
                            </div>
                            <div class="col-6 col-sm-3">
                                <div class="mb-3">
                                <label for="exampleFormControlInput1" class="form-label">{{$t('due_date')}}</label>
                                <input v-model="localData.due_date" type="date" class="form-control" id="exampleFormControlInput1" placeholder="Due Date">
                            </div>
                            </div>
                        </div>

                        <hr>
                        <div class="mb-3">
                            <div v-for="(prd,i) in localData.products" :key="i" class="row mb-3">
                                <!-- Product selector: full width on mobile, compact on sm+ -->
                                <div class="col-12 col-xl-5">
                                    <div class="d-flex align-items-center">
                                        <div class="form-check form-switch">
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                :id="'paymentToggle'+i"
                                                v-model="localData.products[i].custom_product"
                                            >
                                        </div>
                                        <label :for="'paymentToggle'+i" class="form-label toggle-label me-3">{{localData.products[i].custom_product ? $t('custom_product') : $t('existing_product') }}</label>
                                    </div>

                                    <div class="d-flex">
                                        <div class="flex-grow-1">
                                            <auto-complete  
                                                :uid="i"
                                                v-if="!localData.products[i].custom_product" 
                                                @emitAutoComplete="emitAutoComplete" 
                                                :defaultValue="localData.products[i].product_label" 
                                                entity="inventories"
                                                emitEvent="emitAutoComplete"
                                                :dislaySuggestions="action =='create' && !localData.products[i].preventSuggestions ? true : false " 
                                            ></auto-complete>
                                            <textarea v-if="localData.products[i].custom_product" type="string" v-model="localData.products[i].product_label" class="form-control" placeholder="label" min="0"></textarea>
                                        </div>
                                        <button type="button" class="btn line-item-delete-button ms-2 d-block d-sm-none align-self-start" :aria-label="$t('delete')" :title="$t('delete')" @click="removeRow(i)">
                                            <AppIcon name="bi-trash" class="bi bi-trash" />
                                        </button>
                                    </div>
                                </div>
                                <!-- Price -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('price')}}</label>
                                    <input v-model="localData.products[i].price" @focus="handleInputFocus(localData.products[i], 'price')" @blur="handleInputBlur(localData.products[i], 'price', i)" @change="calculatePrices" class="form-control" placeholder="Price" type="number">                                
                                </div>
                                <!-- Qty -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('qty')}}</label> 
                                    <select v-if="!localData.products[i].custom_quantity_mode" class="form-select" :value="Number(localData.products[i].quantity)" @change="onQuantityChange(i, $event)">
                                        <option :value="0">0</option>
                                        <option :value="1">1</option>
                                        <option :value="2">2</option>
                                        <option :value="3">3</option>
                                        <option :value="4">4</option>
                                        <option :value="5">5</option>
                                        <option :value="6">6</option>
                                        <option :value="7">7</option>
                                        <option :value="8">8</option>
                                        <option :value="9">9</option>
                                        <option :value="10">10</option>
                                        <option value="custom">Custom</option>
                                    </select>
                                    <div v-else class="input-group">
                                        <input v-model="localData.products[i].quantity" @focus="handleInputFocus(localData.products[i], 'quantity')" @blur="handleInputBlur(localData.products[i], 'quantity', i)" @change="calculatePrices" class="form-control" min="0" type="number" step="any" inputmode="decimal" >
                                        <button class="btn btn-outline-secondary" type="button" @click="switchToSelectMode(i)" style="padding: 0 5px;">
                                            <AppIcon name="bi-list" class="bi bi-list" />
                                        </button>
                                    </div>
                                </div>
                                <!-- VAT -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('vat')}} %</label>
                                    <select v-if="!localData.products[i].custom_vat_mode" class="form-select" :value="Number(localData.products[i].vat)" @change="onVatChange(i, $event)">
                                        <option :value="0">0%</option>
                                        <option :value="5">5%</option>
                                        <option :value="10">10%</option>
                                        <option :value="20">20%</option>
                                        <option :value="30">30%</option>
                                        <option value="custom">Custom</option>
                                    </select>
                                    <div v-else class="input-group">
                                        <input v-model.number="localData.products[i].vat" @focus="handleInputFocus(localData.products[i], 'vat')" @blur="handleInputBlur(localData.products[i], 'vat', i)" @change="calculatePrices" class="form-control" min="0" max="100" type="number" step="0.01" inputmode="decimal" pattern="[0-9]+(\.[0-9]{1,2})?" >
                                        <button class="btn btn-outline-secondary" type="button" @click="switchToVatSelectMode(i)" style="padding: 0 5px;">
                                            <AppIcon name="bi-list" class="bi bi-list" />
                                        </button>
                                    </div>
                                </div>
                                <!-- Subtotal -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('sub_total')}}: </label>
                                    <input v-model="localData.products[i].sub_total" @focus="handleInputFocus(localData.products[i], 'sub_total')" @blur="handleInputBlur(localData.products[i], 'sub_total', i)" class="form-control" min="0" max="100" type="number" step="0.01" inputmode="decimal"  >
                                </div>
                                <!-- Discount -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('discount')}} %</label>
                                    <select v-if="!localData.products[i].custom_discount_mode" class="form-select" :value="Number(localData.products[i].discount)" @change="onDiscountChange(i, $event)">
                                        <option :value="0">0%</option>
                                        <option :value="5">5%</option>
                                        <option :value="10">10%</option>
                                        <option :value="15">15%</option>
                                        <option :value="20">20%</option>
                                        <option :value="25">25%</option>
                                        <option :value="30">30%</option>
                                        <option :value="50">50%</option>
                                        <option value="custom">Custom</option>
                                    </select>
                                    <div v-else class="input-group">
                                        <input v-model="localData.products[i].discount" @focus="handleInputFocus(localData.products[i], 'discount')" @blur="handleInputBlur(localData.products[i], 'discount', i)" @change="calculatePrices" class="form-control"  min="0" max="100" type="number" step="0.01" inputmode="decimal">
                                        <button class="btn btn-outline-secondary" type="button" @click="switchToDiscountSelectMode(i)" style="padding: 0 5px;">
                                            <AppIcon name="bi-list" class="bi bi-list" />
                                        </button>
                                    </div>
                                </div>
                                <!-- Total -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('total')}}: </label>
                                    <input v-model="localData.products[i].total" @focus="handleInputFocus(localData.products[i], 'total')" @blur="handleInputBlur(localData.products[i], 'total', i)" class="form-control" @change="parseTTctoHt(i,localData.products[i].total)"  min="0" type="number" step="0.01" inputmode="decimal" >
                                </div>
                                <!-- Remove button -->
                                <div class="col-12 col-xl-1 d-none d-sm-block"  style="margin-top:25px">
                                    <button type="button" class="mb-3 btn line-item-delete-button" :aria-label="$t('delete')" :title="$t('delete')" @click="removeRow(i)"><AppIcon name="bi-trash" class="bi bi-trash" /></button>
                                </div>
                                <div class="col-12 d-block d-sm-none">
                                    <hr>
                                </div>
                            </div>  

                            <div class="row">
                                <div class="col-sm-9 btn-add-product">
                                    <button type="button" class="mb-3 btn btn-success" @click="addNewRow"><PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" /> {{$t('product')}}</button>
                                </div>
                                <div class="col-sm-3" v-if="checkIfValidProduct()">
                                    <span>{{$t('sub_total')}} : <b>{{formatMoney(sub_total)}} </b> <br></span>
                                    <span>{{$t('vat')}} : <b>{{formatMoney(totalTvaPrice())}} </b></span> <br>
                                    <span v-if="total_discounted && total_discounted > 0">{{$t('discount')}} : <b>- {{formatMoney(total_discounted)}} </b> <br></span>
                                    <span>{{$t('total')}} : <b>{{ formatMoney(total) }} </b> <br></span>
                                </div>
                            </div>
                            
                        </div>

                        <hr>
                        <div class="row">
                            <div class="col-sm-3">
                                <label for="exampleFormControlInput1" class="form-label"><strong>{{$t('supplier')}}</strong></label>
                                <auto-complete  
                                        v-if="!modalIsLoading" 
                                        @emitAutoCompleteSupplier="emitAutoCompleteSupplier" 
                                        :defaultValue="localData?.supplier?.name"
                                        entity="suppliers"
                                        emitEvent="emitAutoCompleteSupplier"
                                ></auto-complete>
                                <a href="#" class="related-create-link d-block mt-1 small text-decoration-none" @click.prevent="openCreateSupplierModal">
                                    <AppIcon name="bi-plus-circle" class="bi bi-plus-circle me-1" />{{$t('create_new_supplier')}}
                                </a>
                            </div>
                        </div>

                        <hr v-if="checkIfValidProduct()">
                        <div class="table-responsive mb-4" v-if="localData.transactions && localData.transactions.length">
                            <label for="exampleFormControlInput1" class="form-label"><b>{{$t('payments_history')}}</b></label>
                            <table class="table mb-0 table-borderless table-striped small">
                                <thead>
                                    <tr class="text-secondary">
                                        <th class="pt-4 pb-3 px-6">{{$t('reference')}}</th>
                                        <th class="pt-4 pb-3 px-6">{{$t('amount')}}</th>
                                        <th class="pt-4 pb-3 px-6">{{$t('payment_method')}}</th>
                                        <th class="pt-4 pb-3 px-6">{{$t('status')}}</th>
                                        <th class="pt-4 pb-3 px-6">{{$t('created_at')}}</th>
                                    </tr>
                                </thead>
                                <tbody>

                                <tr v-for="transaction in localData.transactions" :key="transaction.id">
                                    <td class="py-5 px-6">
                                        <router-link :to="`/payments/${transaction.id}`" target="_blank">
                                            <b>{{transaction.reference}}</b>
                                        </router-link>
                                    </td>
                                    <td class="py-5 px-6">{{transaction.amount}}</td>
                                    <td class="py-5 px-6">{{transaction.payment_method}}</td>
                                    <td class="py-5 px-6">
                                        <span :class="{
                                            'badge bg-info': transaction.status === 'draft',
                                            'badge bg-success': transaction.status === 'paid',
                                            'badge bg-warning': transaction.status === 'partially_paid',
                                            'badge bg-danger': transaction.status === 'canceled' || transaction.status === 'overdue',
                                            'badge bg-secondary': transaction.status === 'pending'
                                        }">{{$t(transaction.status)}}</span>
                                    </td>
                                    <td class="py-5 px-6">{{formatDate(transaction.created_at)}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row" v-if="checkIfValidProduct()">
                            <label for="exampleFormControlInput1" class="form-label"><b>{{$t('payment')}}</b></label>
                            <div class="col-sm-2">
                                <label for="exampleFormControlInput1" class="form-label">{{$t('payment_method')}}</label>
                                    <select  v-model="localData.payment_method" class="form-select" aria-label="Default select example">
                                    <option selected value="cash">{{$t('cash')}}</option>
                                    <option value="transfert"><AppIcon name="bi-arrow-left-right" class="bi bi-arrow-left-right" style="font-size:12px" /> {{$t('transfert')}}</option>
                                    <option value="tpe">{{$t('tpe')}}</option>
                                    <option value="cheque">{{$t('cheque')}}</option>
                                </select>
                            </div>
                            <div class="col-sm-2" v-if="localData.payment_method == 'cheque'">
                                <label for="exampleFormControlInput1" class="form-label">{{$t('transaction_id')}}</label>
                                <input v-model="localData.pm_reference" type="number" class="form-control" id="amountPaidInput" min="0" step="0.01" inputmode="decimal" >
                            </div>
                            <div class="col-sm-2">
                                <label for="exampleFormControlInput1" class="form-label">{{$t('status')}}</label>
                                    <select v-model="localData.status" class="form-select" aria-label="Default select example">
                                    <option value="pending">{{$t('pending')}}</option>
                                    <option value="partially_paid">{{$t('partially_paid')}}</option>
                                    <option selected value="paid">{{$t('paid')}}</option>
                                    <option value="canceled">{{$t('canceled')}}</option>
                                    </select>
                            </div>
                            
                            <div class="col-sm-2">
                                <label for="amountPaidInput" class="form-label">{{$t('amount_paid')}}</label>
                                <input v-model="amount_paid" type="number" class="form-control" id="amountPaidInput" placeholder="100" :min="0" :max="total" >
                            </div>

                            <div class="col-sm-2">
                                <label for="amountPaidInput" class="form-label" style="">{{$t('balance_due')}}</label>
                                <div class="p-1" style="font-size:18px;font-weight:bold">{{ formatMoney(total_amount_paid) }} </div>
                            </div>

                        </div>

                        <br>
                        <div class="mb-3">
                            <collapsible-notes-field v-model="localData.notes" id="supplier-invoice-notes" rows="1" />
                        </div>

                        <!-- <div class="mb-3">
                            
                            <span v-if="checkIfValidProduct()" @click="invoiceModalisOpen = true" style="cursor:pointer">
                                <AppIcon name="bi-eye" class="bi bi-eye" style="font-size:12px" />
                                <small>&nbsp;{{$t('preview')}}</small>
                            </span>
                            
                        </div> -->

                    </div>
                    <div class="alert alert-warning" role="alert" v-if="msgError">
                        {{msgError}}
                    </div>
            </template>

            <template #footer>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                <button v-if="action == 'update'" type="button" class="btn btn-success" @click="updateRow" :disabled="!checkIfValidProduct() || loading"> <AppIcon name="bi-pencil" class="bi bi-pencil me-2" style="font-size:12px" />{{$t('edit')}}</button>
                <button v-if="['create','transfer'].includes(action)" type="button" class="btn btn-success" @click="saveRow" :disabled="!checkIfValidProduct() || loading"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('create')}}</button>
            </template>

        </CustomModal>

        <!-- supplier modal -->
        <add-supplier
            v-if="createSupplierState" 
            :state="createSupplierState" 
            @createSupplier="createSupplier"/>
        <!-- supplier modal --> 


        <!-- invoice modal -->
        <invoice-template-modal 
            v-if="invoiceModalisOpen" 
            @modalClosed="invoiceModalisOpen = false" 
            modalId="invoice-invoice-modal-22" 
            :isModalOpen="invoiceModalisOpen"  
            :data="data" 
            type="supplier-invoice">
        </invoice-template-modal>
        <!-- invoice modal -->

    </div>
    
</template>

<script>
import CustomModal from '../CustomModal.vue'
import helper from '../../helper'
import AutoComplete from '../autocomplete/AutoComplete'
import AddSupplier from '../AddSupplier.vue'
import InvoiceTemplateModal from '../invoiceLayout/InvoiceTemplateModal.vue'
import moment from 'moment'
export default {
  name: 'AddEditInvoiceModal',
  props : {
        action: {
            type: String,
            required: true
        },
        data: {
            default: false
        },
        isModalOpen: {
            type: Boolean,
            default: false
        },
        modalId : {
            type : String,
            default : 'exampleModal'
        }
    },
  components : {
    CustomModal,
    AutoComplete,
    AddSupplier,
    InvoiceTemplateModal
  },
  data(){
    const parsedData = (() => {
        const data = JSON.parse(JSON.stringify(this.data));
        if(this.data && this.data.scannedFile) {
            data.scannedFile = this.data.scannedFile;
        }
        return data;
    })();

    let amount_paid = parsedData.amount_paid || 0;
    if (parsedData.transactions && parsedData.transactions.length) {
        amount_paid = parsedData.transactions
            .filter(t => t.status === 'paid')
            .map(t => t.amount)
            .reduce((a, c) => parseFloat(a) + parseFloat(c), 0);
        parsedData.amount_paid = amount_paid;
    }

    return {
        loading : false,
        invoiceModalStatus : false,
        invoiceModalisOpen :false,
        createSupplierState : false,
        hideClient : false,
        localData: parsedData,
        amount_paid : amount_paid,
        modalIsLoading : false,
        msgError : null
    }
  }, 
  computed : {
    business(){ return this.$store.getters.BUSINESS},
    total(){ return this.localData.products.length ? this.localData.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0},
    sub_total(){ return this.localData.products.length ? this.localData.products.map(o => o.sub_total).reduce((a, c) => { return a + c }) : 0},
    total_discounted(){ return this.localData.products.length ? this.localData.products.map(o => o.total_discount).reduce((a, c) => { return a + c }) : 0},
    total_amount_paid(){
        if(this.action === 'update') return (this.localData.total - (parseFloat(this.amount_paid) || 0))
        if(!this.localData.transactions || !this.localData.transactions.length) return (this.localData.total - (parseFloat(this.amount_paid) || 0))
        return (this.localData.total - (this.localData.transactions.map(transaction => transaction.amount).reduce((a,c) => { return parseFloat(a) + parseFloat(c) }) + parseFloat(this.amount_paid || 0)))
    }
  },
  methods : {
    async saveRow(){
        try{
            this.loading = true
            //format products
            this.localData.products = helper.formatProducts(this.localData.products)
            if(!this.localData.supplier_id && this.localData.supplier && this.localData.supplier.id ){
                this.localData.supplier_id = this.localData.supplier.id
            }

            this.localData.amount_paid = this.amount_paid
            
            for(let i = 0 ; i < this.localData.products.length ; i++){
                if(this.localData.products[i].quantity == 0){
                    this.msgError += `${this.$t('product')}: [${this.localData.products[i].product_label}] ${this.$t('quantity')} :[${this.localData.products[i].quantity}] \n`
                }
            }

            if(!this.localData.products.length){
                this.msgError = `No Product Found`
            }

            if(this.msgError !== null) {
                this.loading = false
                return
            }
            
            // Default to 'pending' status for newly created AI scanner invoices
            if(!this.localData.status) {
                this.localData.status = 'pending'
            } 
            
            // Update the existing draft instead of creating a new one
            const payload = {...this.localData}
            delete payload.scannedFile
            const response = await helper.customPatch(`${process.env.VUE_APP_API}/supplier-invoices/${this.localData.id}`, payload, {showToast:true})
            
            if(this.localData.scannedFile){
                await this.uploadAttachment(this.localData.id);
            }

            this.clearForm()
            this.loading = false
            this.modalClosed()
            this.$router.push({path : `/supplier-invoices/${response.data.id}`})

        }catch(error){
            this.loading = false
        }
    },
    async updateRow(){
        try{
            this.loading = true
            //format products
            this.localData.products = helper.formatProducts(this.localData.products)
            if(!this.localData.supplier_id && this.localData.supplier && this.localData.supplier.id ){
                this.localData.supplier_id = this.localData.supplier.id
            }
            this.localData.amount_paid = this.amount_paid
            
            for(let i = 0 ; i < this.localData.products.length ; i++){
                if(this.localData.products[i].quantity == 0){
                    this.msgError += `${this.$t('product')}: [${this.localData.products[i].product_label}] ${this.$t('quantity')} :[${this.localData.products[i].quantity}] \n`
                }
            }

            if(!this.localData.products.length){
                this.msgError = `No Product Found`
            }

            if(this.msgError !== null) {
                this.loading = false
                return
            }

            const payload = {...this.localData}
            delete payload.scannedFile
            await helper.customPatch(`${process.env.VUE_APP_API}/supplier-invoices/${this.localData.id}`, payload)
            
            if(this.localData.scannedFile){
                await this.uploadAttachment(this.localData.id);
            }

            this.loading = false
            this.clearForm()
            this.modalClosed()
            this.$emit('refresh',true)

        }catch(error){
            this.loading = false
        }
    },
    clearForm(){
        this.localData = {
            id : null,
            reference : '',
            supplier_id : null,
            supplier : {},
            date : '',
            total : 0,
            products : []
        }

    },
    addNewRow(){
        this.localData.products.push({
            id : null,
            label : '',
            quantity : 0,
            price : 0,
            discount : 0,
            vat :  this.business.vat,
            total : 0,
            sub_total : 0,
            custom_product : false,
            custom_quantity_mode : false,
            custom_discount_mode : false,
            custom_vat_mode : false,
        })
    },
    removeRow(i){
       this.localData.products.splice(i, 1);
    },
    onQuantityChange(index, event) {
        const val = event.target.value;
        if (val === 'custom') {
            this.localData.products[index].custom_quantity_mode = true;
        } else {
            this.localData.products[index].custom_quantity_mode = false;
            this.localData.products[index].quantity = Number(val);
            this.calculatePrices();
        }
    },
    switchToSelectMode(index) {
        this.localData.products[index].custom_quantity_mode = false;
        this.localData.products[index].quantity = 0;
        this.calculatePrices();
    },
    onDiscountChange(index, event) {
        const val = event.target.value;
        if (val === 'custom') {
            this.localData.products[index].custom_discount_mode = true;
        } else {
            this.localData.products[index].custom_discount_mode = false;
            this.localData.products[index].discount = Number(val);
            this.calculatePrices();
        }
    },
    switchToDiscountSelectMode(index) {
        this.localData.products[index].custom_discount_mode = false;
        this.localData.products[index].discount = 0;
        this.calculatePrices();
    },
    onVatChange(index, event) {
        const val = event.target.value;
        if (val === 'custom') {
            this.localData.products[index].custom_vat_mode = true;
        } else {
            this.localData.products[index].custom_vat_mode = false;
            this.localData.products[index].vat = Number(val);
            this.calculatePrices();
        }
    },
    switchToVatSelectMode(index) {
        this.localData.products[index].custom_vat_mode = false;
        this.localData.products[index].vat = 0;
        this.calculatePrices();
    },
    handleInputFocus(row, field){
        if(row[field] == 0){
            row[field] = ''
        }
    },
    handleInputBlur(row, field, index){
        if(row[field] === '' || row[field] === null || row[field] === undefined){
            row[field] = 0
            if(field === 'total'){
                this.parseTTctoHt(index, 0)
            }else if(['price','quantity','vat','discount'].includes(field)){
                this.calculatePrices()
            }
        }
    },
    calculatePrices() {
      this.msgError = null;
      this.$forceUpdate();

      for (let i = 0; i < this.localData.products.length; i++) {
        let product = this.localData.products[i];

        const qty = Number(product.quantity) || 0;
        const price = Number(product.price) || 0;
        const discountRate = Number(product.discount) || 0;
        const vatRate = Number(product.vat) || 0;

        // Derive unit HT depending on configuration
        let unitPriceHT = 0;
        const productPriceIncludesTax = (product.price_includes_tax === true) || (product.product?.price_includes_tax === true) || (this.business?.price_includes_tax === true);
        if (productPriceIncludesTax) {
          unitPriceHT = vatRate > 0 ? price / (1 + vatRate / 100) : price;
        } else {
          unitPriceHT = price;
        }

        // Subtotal (HT) before discount
        const subTotalHT = unitPriceHT * qty;
        product.sub_total = Math.round(subTotalHT * 100) / 100;

        // Discount (applied on HT)
        const discountAmount = product.sub_total * (discountRate / 100);
        product.total_discount = Math.round(discountAmount * 100) / 100;

        // VAT is applied on the discounted HT base
        const vatBase = product.sub_total - product.total_discount;
        const tvaAmount = vatRate > 0 ? vatBase * (vatRate / 100) : 0;

        // Final total TTC
        product.total = Math.round((vatBase + tvaAmount) * 100) / 100;
      }

      // Global total
      this.localData.total = this.localData.products.length ? this.localData.products.map(o => o.total).reduce((a, c) => a + c, 0): 0;
    },
    totalTvaPrice() {
      let total = 0;
      if (this.localData && this.localData.products.length) {
        for (let i = 0; i < this.localData.products.length; i++) {
          const p = this.localData.products[i];
          const vatRate = Number(p.vat) || 0;
          const subHT = Number(p.sub_total) || 0;
          const discount = Number(p.total_discount) || 0;
          const vatBase = Math.max(subHT - discount, 0);
          total += (vatRate / 100) * vatBase;
        }
      }
      return Math.round(total * 100) / 100;
    }, 
    parseTTctoHt(index, price) {
      if(price === '') return
      const prd = this.localData.products[index];
      const qty = Number(prd?.quantity) || 0;
      const vatRate = Number(prd?.vat) || 0;
      if (price && price > 0 && qty > 0) {
        const unitTTC = Number(price) / qty;
        const productPriceIncludesTax = (prd.price_includes_tax === true) || (prd.product?.price_includes_tax === true) || (this.business?.price_includes_tax === true);
        if (productPriceIncludesTax) {
          // Price field is TTC when business or product prices include tax
          prd.price = unitTTC.toFixed(2);
        } else {
          // Price field is HT when business and product prices exclude tax
          prd.price = (vatRate > 0 ? unitTTC / (1 + vatRate / 100) : unitTTC).toFixed(2);
        }
        // Update HT subtotal
        const unitHT = productPriceIncludesTax
          ? (vatRate > 0 ? unitTTC / (1 + vatRate / 100) : unitTTC)
          : Number(prd.price);
        prd.sub_total = Math.round((unitHT * qty) * 100) / 100;
      }
    },
    emitAutoComplete(data){
        if(!this.localData.products.find(product => product.product_id == data.result.product.id)){
             this.localData.products[data.index] = {
                ...{
                inventory_id : data.result.id,
                product_id : data.result.product.id,
                label : data.result.product.label,
                product_label : data.result.product.label,
                quantity : 0,
                maxQty : data.result.quantity,
                price : data.result.price,
                price_includes_tax : (data.result.product?.price_includes_tax === true) || (data.result.price_includes_tax === true),
                unity : data.result.unity,
                purchase_price : data.result.purchase_price ? data.result.purchase_price : 0,
                vat :  data.result.vat ? data.result.vat : this.business.vat,
                total : data.result.total ? data.result.total : 0,
                sub_total : data.result.sub_total ? data.result.sub_total : 0,
                custom_product : false,
                custom_quantity_mode : false,
                custom_discount_mode : false,
                custom_vat_mode : false,
            }}
            this.localData.products = [...this.localData.products]
        }
       
    },
    emitAutoCompleteSupplier(data){
        this.localData.supplier_id = data.result.id
        this.localData.supplier = data.result
    },
    openCreateSupplierModal(){
        this.createSupplierState = !this.createSupplierState
    },
    createSupplier(data){
        if(data.supplier){
            this.localData.supplier_id = data.supplier.id
            this.localData.supplier = data.supplier
        }
        if(data && data.state != undefined){
            this.createSupplierState = data.state
            this.modalIsLoading = true
            setTimeout(() => { this.modalIsLoading = false })
        }
    },
    emitAutoCompletePurchase(data){
        this.modalIsLoading = true
        this.localData.products = data.result.products
        this.localData.purchase_id = data.result.id
        this.localData.supplier_id = data.result.supplier_id
        this.localData.supplier = data.result.supplier
        this.calculatePrices()
        setTimeout(() => { this.modalIsLoading = false })
    },
    checkIfValidProduct(){
        return this.localData.products.find(product => product.product_id != null || product.custom_product === true) ? true : false
    },
    modalClosed(){
        this.isModalOpen = false 
        if(document.getElementById('close-modal-btn')){
            document.getElementById('close-modal-btn').click()
        }
        this.clearForm()
        this.$emit('modalClosed', true)
    },
    //helper functions
    formatDate(date,locale) { return helper.formatDate(date,locale) },
    formatMoney(number) { return helper.formatMoney(number);},
    async matchScannedProducts(){
        if(!this.localData.products || !this.localData.products.length) return;

        for(let i = 0; i < this.localData.products.length; i++){
            const product = this.localData.products[i];
            this.localData.products[i].preventSuggestions = true;
            if(product.custom_product && product.label){
                try {
                    const response = await helper.customGet(`${process.env.VUE_APP_API}/inventories?keyword=${encodeURIComponent(product.label)}&per_page=1`);
                    if(response.data && response.data.data && response.data.data.length > 0){
                        const match = response.data.data[0];
                        // If we find a match, link it but preserve scanned quantity/price
                        this.localData.products[i] = {
                            ...this.localData.products[i],
                            inventory_id : match.id,
                            product_id : match.product.id,
                            label : match.product.label,
                            product_label : match.product.label,
                            maxQty : match.quantity,
                            unity : match.unity,
                            custom_product : false,
                            preventSuggestions: true
                        };
                    }
                } catch (e) {
                   alert(e)
                }
            }
        }
        this.localData.products = [...this.localData.products];
        this.calculatePrices();
    },
    async uploadAttachment(invoiceId){
        try {
            await helper.customUploadFile(this.localData.scannedFile, `businesses/${this.business.id}/attachments/${helper.generateRandString(20)}`, {
                // Supplier-invoice details use the shared invoice attachment type.
                entity_type: 'invoice',
                entity_id: invoiceId,
                is_private: 0,
                notes: 'Scanned Invoice'
            });
        } catch (e) {
            throw new Error("Failed to upload attachment");
        }
    },
  },
  async created(){

    if(this.localData.date) {
        this.localData.date = moment(this.localData.date).format('YYYY-MM-DD')
    }else{
        this.localData.date = moment().format('YYYY-MM-DD')
    }

    if(this.localData.due_date) {
        this.localData.due_date = moment(this.localData.due_date).format('YYYY-MM-DD')
    }

    this.calculatePrices()

    if(this.localData.products.length){
        for(let i = 0 ; i < this.localData.products.length ; i++){
            if(!this.localData.products[i].discount){
                this.localData.products[i].discount = 0
            }
        }
    }

    //add default status & payment method 
    if(!this.localData.status){
        this.localData.status = 'draft'
    }

    if(!this.localData.payment_method){
        this.localData.payment_method = 'cash'
    }

    if(this.localData.purchase){
        this.localData.purchase_id = this.localData.purchase.id
    }

    // When creating, immediately create a draft on the server and keep its id/reference
    // We only create a new draft if no ID is already provided (normal creation)
    // or if we're transferring from another document (which requires a new invoice ID)
    if((this.action === 'create' && !this.localData.id) || this.action === 'transfer'){
        const { data } = await helper.customPost(`${process.env.VUE_APP_API}/supplier-invoices/draft`,{})
        this.localData.id = data.id
        
        if(!this.localData.isScanned){
            this.localData.reference = data.reference
            if(data.date){
                this.localData.date = moment(data.date).format('YYYY-MM-DD')
            }
        }
    }

    if(this.localData.isScanned){
        this.loading = true;
        await this.matchScannedProducts();
        this.loading = false;
    }
  },
  watch : {
        'amount_paid'(newAmount) {
            if (newAmount >= this.localData.total) {
                this.localData.status = 'paid';
            } else if (newAmount != 0 && this.localData.amount_paid < this.localData.total){
                this.localData.status = 'partially_paid';
            } else if (newAmount == 0) {
                this.localData.status = 'pending';
            } 
        },
         'localData.status'(newVal){
            if(newVal == 'paid'){
                this.amount_paid = this.localData.total
            }
        }
  }
}
</script>

<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
</style>
